import * as MUI from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { CURRENCIES } from "../warehouse/utils/stockStatus";

export default function WarehousePricingSettings({
  priceEntryMode,
  onPriceEntryModeChange,
  defaultVat,
  onDefaultVatChange,
  currency,
  onCurrencyChange,
}) {
  const { t } = useTranslation();

  return (
    <MUI.Stack spacing={2}>
      <MUI.FormControl fullWidth>
        <MUI.InputLabel id="price-entry-mode-label">{t("PriceEntryMode")}</MUI.InputLabel>
        <MUI.Select
          labelId="price-entry-mode-label"
          label={t("PriceEntryMode")}
          value={priceEntryMode}
          onChange={(e) => onPriceEntryModeChange(e.target.value)}
        >
          <MUI.MenuItem value="NETTO">{t("PriceEntryNetto")}</MUI.MenuItem>
          <MUI.MenuItem value="BRUTTO">{t("PriceEntryBrutto")}</MUI.MenuItem>
        </MUI.Select>
      </MUI.FormControl>
      <MUI.TextField
        fullWidth
        type="number"
        label={t("DefaultVat")}
        value={defaultVat}
        onChange={(e) => onDefaultVatChange(e.target.value)}
        inputProps={{ min: 0, max: 100, step: "0.01" }}
      />
      <MUI.FormControl fullWidth>
        <MUI.InputLabel id="warehouse-currency-label">{t("Currency")}</MUI.InputLabel>
        <MUI.Select
          labelId="warehouse-currency-label"
          label={t("Currency")}
          value={currency}
          onChange={(e) => onCurrencyChange(e.target.value)}
        >
          {Object.entries(CURRENCIES).map(([code, { labelKey, Icon }]) => (
            <MUI.MenuItem key={code} value={code}>
              <MUI.Stack direction="row" spacing={1} alignItems="center">
                <Icon fontSize="small" />
                <span>{t(labelKey)}</span>
              </MUI.Stack>
            </MUI.MenuItem>
          ))}
        </MUI.Select>
      </MUI.FormControl>
    </MUI.Stack>
  );
}
